// AUTO-GENERATED by scripts/build-registry.js: study entry for aeronautics/variation-deviation-conversion.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/aeronautics/variation-deviation-conversion/variation-deviation-conversion.js';
import g1 from '../lessons/aeronautics/variation-deviation-conversion/variation-deviation-reference.js';

mount([g0, g1]);
